import * as Swiper from "../libs/swiper";

export function swipeSlider() {
    $(window).on("load", function () {
        const slider = $(".swipe-slider");

        const sliderSettings = {
            slidesPerView: "1",
            spaceBetween: 30,
            watchOverflow: true,
            freeMode: true,
            mousewheel: true,
            direction: "horizontal",
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                hide: false,
                snapOnRelease: true,
            },
        };

        const mySwiper = new Swiper(slider, sliderSettings);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/swipe-slider.js